export default __webpack_public_path__ + "static/media/f_wdt_c_4_5.d35fe9ff.mp3";